import React, { useState, useEffect } from "react";
import UserSidebar from "./UserSidebar";
import UserHeader from "./UserHeader";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../api_call";
import "./Dashboard.css";

export default function ReportDataBreach() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  // -------------------- Form state --------------------
  const [formData, setFormData] = useState({
    task_name: "",
    task_start_date: "",
    task_end_date: "",
    task_action_date: "",
    task_reminder_days: 1,
    add_escalation: false, 
    task_escalation_email: "",
    task_escalation_reminder_days: "",
  });

  const [errors, setErrors] = useState({});
  const [successMsg, setSuccessMsg] = useState("");
  const [successVisible, setSuccessVisible] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  // -------------------- Input handler --------------------
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors({});
    setSuccessMsg("");
  };

  // -------------------- Form submit --------------------
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setSuccessMsg("");

    // Basic validation
    const newErrors = {};
    if (!formData.task_start_date) newErrors.task_start_date = "Required";
    if (!formData.task_end_date) newErrors.task_end_date = "Required";
    if (!formData.task_action_date) newErrors.task_action_date = "Required";
    if (!formData.task_name) newErrors.task_name = "Required";
    if (formData.add_escalation && !formData.task_escalation_email) {
      newErrors.task_escalation_email = "Required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      setSubmitting(true);

      const payload = {
  task_name: formData.task_name, // 🔹 NEW
  task_start_date: formData.task_start_date,
  task_end_date: formData.task_end_date,
  task_action_date: formData.task_action_date,
  task_reminder_days: Number(formData.task_reminder_days),
  task_escalation_email: formData.add_escalation
    ? formData.task_escalation_email
    : "",
  task_escalation_reminder_days: formData.add_escalation
    ? Number(formData.task_escalation_reminder_days)
    : 0,
};

      const res = await apiFetch("/data-breach/add", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (res?.error) throw res;

      setSuccessMsg("✅ Data breach reported successfully");
      setSuccessVisible(true);

      setTimeout(() => {
        setSuccessVisible(false);
        navigate("/manage-data-breach");
      }, 2000);
    } catch (err) {
      console.error(err);
      setErrors({ api: err?.error || "❌ Failed to report data breach" });
    } finally {
      setSubmitting(false);
    }
  };

  // -------------------- Auto-hide success message --------------------
  useEffect(() => {
    if (successMsg) {
      const timer = setTimeout(() => setSuccessVisible(false), 4000);
      const clearMsg = setTimeout(() => setSuccessMsg(""), 4500);
      return () => {
        clearTimeout(timer);
        clearTimeout(clearMsg);
      };
    }
  }, [successMsg]);

  return (
    <div className="add_compliance">
      <UserSidebar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <UserHeader menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

      <div className="form-container">
        <h2>Report a Data Breach</h2>

        {/* Messages */}
        <div
          className="messages-top"
          style={{ margin: "0 auto 1rem auto", width: "50%" }}
        >
          {errors.api && <div className="login-error">{errors.api}</div>}
          {successMsg && (
            <div className={`success-msg ${!successVisible ? "fade-out" : ""}`}>
              {successMsg}
            </div>
          )}
        </div>

        <form onSubmit={handleSubmit} className="add-user-form">
          <label>
  Report Name
  <input
    type="text"
    name="task_name"
    value={formData.task_name}
    onChange={handleInputChange}
  />
  {errors.task_name && (
    <span className="error">{errors.task_name}</span>
  )}
</label><label></label>
          <label>
            Start Date
            <input
              type="date"
              name="task_start_date"
              value={formData.task_start_date}
              onChange={handleInputChange}
            />
            {errors.task_start_date && (
              <span className="error">{errors.task_start_date}</span>
            )}
          </label>

          <label>
            End Date
            <input
              type="date"
              name="task_end_date"
              value={formData.task_end_date}
              onChange={handleInputChange}
            />
            {errors.task_end_date && (
              <span className="error">{errors.task_end_date}</span>
            )}
          </label>

          <label>
            Action Date
            <input
              type="date"
              name="task_action_date"
              value={formData.task_action_date}
              onChange={handleInputChange}
            />
            {errors.task_action_date && (
              <span className="error">{errors.task_action_date}</span>
            )}
          </label>

          <label>
            Reminder Days
            <input
              type="number"
              min="1"
              name="task_reminder_days"
              value={formData.task_reminder_days}
              onChange={handleInputChange}
              style={{ width: "60px" }}
            />
          </label>

          {/* 🔔 ADD ESCALATION */}
          <div>
            <input
              type="checkbox"
              name="add_escalation"
              checked={formData.add_escalation}
              onChange={handleInputChange}
            />
            Add Escalation<sup><i>Optional</i></sup>
          </div>
          <div></div>

          <label>
            Escalation Email
            <input
              type="email"
              name="task_escalation_email"
              value={formData.task_escalation_email}
              onChange={handleInputChange}
              readOnly={!formData.add_escalation}
              style={{
                backgroundColor: formData.add_escalation ? "white" : "#f0f0f0",
                cursor: formData.add_escalation ? "text" : "not-allowed",
              }}
            />
            {errors.task_escalation_email && (
              <span className="error">{errors.task_escalation_email}</span>
            )}
          </label>

          <label>
            Escalation Reminder Days
            <input
              type="number"
              name="task_escalation_reminder_days"
              value={formData.task_escalation_reminder_days}
              onChange={handleInputChange}
              readOnly={!formData.add_escalation}
              style={{
                width: "60px",
                backgroundColor: formData.add_escalation ? "white" : "#f0f0f0",
                cursor: formData.add_escalation ? "text" : "not-allowed",
              }}
            />
          </label>

          <button
            type="submit"
            className="submit-btn"
            disabled={submitting}
            style={{ opacity: submitting ? 0.6 : 1 }}
          >
            {submitting ? "Reporting..." : "Add Data Breach Tasks"}
          </button>
        </form>
      </div>
    </div>
  );
}